/** en-GB messages for the "Get the apps" page and the platform app download settings (task p2/apps). Flat keys, merged into enGB by ./index.ts. */
export const appsEnGB = {
    'nav.apps': 'Get the apps',
    // Platform settings labels (core.apps)
    'settings.core.apps': 'App downloads',
    'settings.core.apps.kiosk': 'CloudSign Kiosk (reception tablet)',
    'settings.core.apps.companion': 'CloudSign (staff phone app)',
    'settings.core.apps.kiosk.enabled': 'Show on the Get the apps page',
    'settings.core.apps.kiosk.url': 'Download link (https, on expo.dev or cloudsign.uk)',
    'settings.core.apps.kiosk.version': 'Version label, for example 0.1.0 (23 Oct 2026)',
    'settings.core.apps.companion.enabled': 'Show on the Get the apps page',
    'settings.core.apps.companion.url': 'Download link (https, on expo.dev or cloudsign.uk)',
    'settings.core.apps.companion.version': 'Version label, for example 0.1.0 (23 Oct 2026)',
    'error.app_url_invalid': 'The link must start with https:// and be on expo.dev or cloudsign.uk.',
    'error.app_url_required': 'Add a download link before switching this app on.',
    // Page
    'apps.title': 'Get the apps',
    'apps.description': 'Install CloudSign on your Android devices.',
    'apps.empty.title': 'The apps are not available yet',
    'apps.empty.body': 'Nothing has been published for download so far. Please check back soon.',
    'apps.kiosk.name': 'CloudSign Kiosk',
    'apps.kiosk.purpose': 'For the reception tablet. Visitors sign in and out on it.',
    'apps.companion.name': 'CloudSign',
    'apps.companion.purpose': 'The staff phone app. Your QR code, pre-arrivals and notifications.',
    'apps.version': 'Version {version}',
    'apps.download': 'Download {name}',
    'apps.qr.alt': 'QR code for the {name} download link',
    'apps.qr.help': 'Scan this with the device you want to install it on.',
    'apps.steps.title': 'How to install',
    'apps.steps.open': 'Open this page on the Android device in Chrome, or scan the QR code, and tap Download.',
    'apps.steps.allow': 'If asked, allow Chrome to install apps from this source, then open the downloaded file.',
    'apps.steps.kiosk': 'Open the app and pair it with a code from Manage > Devices in this portal.',
    'apps.steps.companion': 'Open the app and sign in with the link your administrator sent you.',
};
//# sourceMappingURL=apps.js.map